import { JobsUtils } from '@fibo-app/fibo-collab-shared'

const ScheduleUtils = {

  getSortedInstancesIds: (instances, calendarEvents, calendarDisplay, calendarId, dateStr) => {
    const jobs = []
    const result = []
    // Add jobs with info to the jobs array which is going to be sorted after that.
    // Jobs without info will be added to the start of the list.
    for (const instance of instances) {
      if (calendarEvents[instance.eventId]) {
        jobs.push(calendarEvents[instance.eventId])
      }
      else {
        result.push(instance.eventId)
      }
    }
    const displayProps = calendarDisplay
      && calendarDisplay[calendarId]
      && calendarDisplay[calendarId][dateStr]
    const sorted = JobsUtils.sort(jobs, displayProps)
    for (const job of sorted) {
      result.push(job.id)
    }
    return result
  }

}

export default ScheduleUtils



// WEBPACK FOOTER //
// ./src/schedule/common/ScheduleUtils.js